module.exports = __webpack_public_path__ + "static/media/simple-line-icons_ghost.776cdaa8.png";